import React from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './DateRangePicker.css';
import { CalendarIcon } from '@heroicons/react/24/outline';
import { it } from 'date-fns/locale/it';

// Registra la locale italiana
registerLocale('it', it);

const DateRangePicker = ({ 
  startDate, 
  endDate, 
  onDatesChange,
  placeholderStart = 'Seleziona data inizio',
  placeholderEnd = 'Seleziona data fine',
  className = '' 
}) => {
  const handleStartDateChange = (date) => {
    if (date) {
      // Adjust for timezone offset to ensure the correct date is selected
      const userTimezoneOffset = date.getTimezoneOffset() * 60000;
      const adjustedDate = new Date(date.getTime() - userTimezoneOffset);
      const formatted = adjustedDate.toISOString().split('T')[0];
      onDatesChange({ startDate: formatted, endDate: endDate });
    } else {
      // Se viene cancellata, passa stringa vuota
      onDatesChange({ startDate: '', endDate: endDate });
    }
  };

  const handleEndDateChange = (date) => {
    if (date) {
      // Adjust for timezone offset to ensure the correct date is selected
      const userTimezoneOffset = date.getTimezoneOffset() * 60000;
      const adjustedDate = new Date(date.getTime() - userTimezoneOffset);
      const formatted = adjustedDate.toISOString().split('T')[0];
      onDatesChange({ startDate: startDate, endDate: formatted });
    } else {
      // Se viene cancellata, passa stringa vuota
      onDatesChange({ startDate: startDate, endDate: '' });
    }
  };

  // Converti stringhe ISO in oggetti Date
  const startDateObj = startDate ? new Date(startDate + 'T00:00:00') : null;
  const endDateObj = endDate ? new Date(endDate + 'T00:00:00') : null;

  return (
    <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 ${className}`}>
      <div>
        <div className="relative">
          <CalendarIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 sm:h-5 sm:w-5 text-gray-400 pointer-events-none z-10" />
          <DatePicker
            selected={startDateObj}
            onChange={handleStartDateChange}
            selectsStart
            startDate={startDateObj}
            endDate={endDateObj}
            maxDate={endDateObj || new Date()}
            dateFormat="dd/MM/yyyy"
            locale="it"
            placeholderText={placeholderStart}
            className="w-full pl-9 sm:pl-10 pr-4 py-2.5 text-sm sm:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
            wrapperClassName="w-full"
            calendarClassName="shadow-xl border-gray-200"
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            isClearable
          />
        </div>
      </div>
      
      <div>
        <div className="relative">
          <CalendarIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 sm:h-5 sm:w-5 text-gray-400 pointer-events-none z-10" />
          <DatePicker
            selected={endDateObj}
            onChange={handleEndDateChange}
            selectsEnd
            startDate={startDateObj}
            endDate={endDateObj}
            minDate={startDateObj}
            maxDate={new Date()}
            dateFormat="dd/MM/yyyy"
            locale="it"
            placeholderText={placeholderEnd}
            className="w-full pl-9 sm:pl-10 pr-4 py-2.5 text-sm sm:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
            wrapperClassName="w-full"
            calendarClassName="shadow-xl border-gray-200"
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            isClearable
          />
        </div>
      </div>
    </div>
  );
};

export default DateRangePicker;

